// Contenido del Centro de Ayuda. Cada tema describe un módulo con el formato
// dolor → cómo lo resuelve → beneficio. `kw` son sinónimos para el buscador.

export const TEMAS = [
  {
    id: 'g-arranque',
    num: '★',
    parte: 'Guías',
    chip: 'Admin',
    titulo: 'Guía de inicio — el club arranca solo',
    kw: 'onboarding primeros pasos guia inicio arrancar configurar checklist orden inscribir inscripciones temporada',
    intro:
      'La pantalla Hoy muestra al administrador la tarjeta "Primeros pasos", agrupada en cuatro etapas: configura tu club, suma a tu gente, empieza a cobrar y opera tu club. Los pasos se marcan solos conforme el club captura datos reales y cada uno enlaza a su pantalla. Hay un quinto bloque opcional, "Compite", para cuando el club entre a un torneo. Si tu plan no incluye un módulo, esa etapa aparece bloqueada en vez de pendiente: no cuenta en el avance.',
    pasos: [
      { label: 'Configura tu organización (datos legales)', id: 'm25' },
      { label: 'Crear categorías', id: 'm24' },
      { label: 'Abrir temporada', id: 'm24' },
      { label: 'Crear grupos', id: 'm24' },
      { label: 'Invitar staff', id: 'm23' },
      { label: 'Registrar jugadores', id: 'm21' },
      { label: 'Inscribir a la temporada (el paso que más se olvida)', id: 'm24' },
      { label: 'Asignar jugadores a un grupo', id: 'm24' },
      { label: 'Definir conceptos de cobro', id: 'm18' },
      { label: 'Crear plan de pago', id: 'm12' },
      { label: 'Asignar el plan a jugadores, grupos o familias', id: 'm12' },
      { label: 'Programar los entrenamientos', id: 'm05' },
      { label: 'Tomar tu primera asistencia', id: 'm03' },
      { label: 'Registrar tu primer pago', id: 'm13' },
    ],
    beneficio: 'Un club nuevo queda operando en su primera sesión de trabajo, sin pasos olvidados.',
  },
  {
    id: 'm01',
    num: '01',
    parte: 'El día a día',
    chip: 'Todos los roles',
    titulo: 'Hoy — la pantalla de arranque',
    kw: 'hoy inicio landing tomar asistencia juegos de hoy pendiente',
    dolor:
      'El coach llega a la cancha y pasar lista está enterrado detrás de menús. Cada minuto buscando en la app es un minuto que no entrena.',
    solucion: [
      { t: 'Entrenamientos de hoy', d: 'una tarjeta por grupo con hora y botón de un clic — "Tomar asistencia". Un badge indica si ya se tomó o sigue pendiente.' },
      { t: 'Juegos de hoy', d: 'lo mismo para partidos.' },
      { t: 'Asistencia de otro grupo', d: 'si surge una práctica no programada, se levanta asistencia igual.' },
    ],
    beneficio: 'De abrir la app a estar pasando lista hay un clic. El sistema ya sabe qué toca hoy.',
  },
  {
    id: 'm02',
    num: '02',
    parte: 'El día a día',
    chip: 'Todos los roles',
    titulo: 'Mis grupos — el panel 360° de cada equipo',
    kw: 'grupos equipo roster staff detalle porcentaje asistencia indicadores',
    dolor:
      'La información del grupo vive dispersa: el roster en un Excel, el horario en el chat, los torneos en la cabeza del coach.',
    solucion: [
      { t: 'Indicadores de un vistazo', d: 'series activas, % de asistencia (verde arriba de 85%) y estado del roster.' },
      { t: 'Staff asignado', d: 'con su rol en el grupo, y controles para asignar o remover.' },
      { t: 'Entrenamientos', d: 'series con días, horario y promedio de asistencias, retardos y faltas.' },
      { t: 'Torneos del grupo', d: 'récord, puntos, rol de juegos y acceso al tarjetón.' },
      { t: 'Jugadores', d: 'roster con fotos, filtros y gestión de altas y bajas.' },
    ],
    beneficio: 'Cualquier persona autorizada — no solo "la que sabe" — responde en segundos cómo va un grupo.',
  },
  {
    id: 'm03',
    num: '03',
    parte: 'El día a día',
    chip: 'Todos los roles',
    titulo: 'Asistencia — pasar lista en segundos',
    kw: 'asistencia pasar lista presente retardo ausente exento celular movil terminar sesion reactivar',
    dolor:
      'La lista en papel se pierde, no suma sola y nadie la recaptura. El club no conoce su dato más básico: quién viene a entrenar.',
    solucion: [
      { t: 'Tocar tarjetas', d: 'cada jugador cicla entre Presente → Retardo → Ausente → Exento. Cada toque se guarda al instante.' },
      { t: 'Contadores en vivo', d: 'y acciones masivas: "Todos presentes" / "Todos ausentes".' },
      { t: 'Buscador', d: 'por nombre, número o apodo para rosters grandes.' },
      { t: 'Terminar sesión', d: 'los no marcados quedan como ausentes (con confirmación). La sesión cerrada queda protegida, pero puede reactivarse.' },
      { t: 'Asistencia de juegos', d: 'mismo flujo, y al terminar se captura el marcador que alimenta el torneo.' },
    ],
    beneficio:
      'El dato se captura en la cancha, en el momento — y de ese único registro salen la agenda visual, el reporte mensual y los promedios del grupo.',
  },
  {
    id: 'm04',
    num: '04',
    parte: 'El día a día',
    chip: 'Todos los roles',
    titulo: 'Agenda de entrenamientos — el mapa del mes',
    kw: 'agenda calendario mapa calor huecos sesiones sin asistencia en curso terminado',
    dolor: '"¿Se dio el entrenamiento del martes? ¿Quién no ha pasado lista?" Revisar sesión por sesión es inviable.',
    solucion: [
      { t: 'Cuadrícula serie × día', d: 'tipo mapa de calor: sin asistencia, en curso, terminado.' },
      { t: 'Filtros', d: 'por rango de fechas, grupos y series.' },
      { t: 'Clic en una celda', d: 'presentes, retardos, ausentes — y botones para abrir esa asistencia o terminarla.' },
    ],
    beneficio: 'El admin detecta de un golpe dónde hay huecos, sin perseguir a nadie por WhatsApp.',
  },
  {
    id: 'm05',
    num: '05',
    parte: 'El día a día',
    chip: 'Admin',
    titulo: 'Series — programa una vez, entrena toda la temporada',
    kw: 'series entrenamientos regulares recurrentes horario generador eventos calendario temporada',
    dolor:
      'Crear a mano cada entrenamiento de cada semana es trabajo repetitivo que nadie hace — y sin sesiones no hay asistencia.',
    solucion: [
      { t: 'Una serie', d: 'define el patrón recurrente: grupo(s), días, horario, ubicación, periodo.' },
      { t: 'El generador', d: 'crea todas las sesiones del rango elegido (hasta 6 meses), sin duplicar.' },
      { t: 'Multi-grupo', d: 'la misma serie se crea para varios grupos a la vez.' },
    ],
    beneficio: 'Cinco minutos de configuración producen el calendario completo de la temporada.',
  },
  {
    id: 'm06',
    num: '06',
    parte: 'El día a día',
    chip: 'Incluido en todos los planes',
    titulo: 'Asistencia mensual — el reporte que piden',
    kw: 'reporte mensual asistencia excel imprimir matriz porcentaje faltas justificado sabana',
    dolor: 'Armar "la sábana" de jugadores × fechas con porcentajes toma horas cada mes, y siempre hay errores.',
    solucion: [
      { t: 'Matriz automática', d: 'filas de jugadores, columnas por fecha, con código de color (P, R, F, J, E).' },
      { t: 'Totales y % de asistencia', d: 'por jugador; filtros por grupo, mes, año y serie.' },
      { t: 'Exportable a Excel e imprimible', d: 'con formato.' },
    ],
    beneficio: 'El reporte que costaba una tarde ahora son dos clics — y es exacto, porque sale de lo marcado en la cancha.',
  },
  {
    id: 'm07',
    num: '07',
    parte: 'Entrenamientos',
    chip: 'Plan Club+',
    titulo: 'Programas de entrenamiento',
    kw: 'programas rutinas ejercicios secciones biblioteca plantillas habilidades flyer imprimible material drills',
    dolor:
      'La calidad del entrenamiento depende de la memoria del coach. Las rutinas no se documentan ni se reutilizan, y en la cancha el calentamiento se come 20 minutos de la parte técnica.',
    solucion: [
      { t: 'Editor de programas', d: 'secciones con duración exacta (calentamiento, técnica, competitivo, cierre…), habilidades que trabaja, etiquetas y material adjunto — hasta fotos tomadas con la cámara.' },
      { t: 'Plantillas de sección', d: 'los bloques que se repiten se guardan y se importan a cualquier programa.' },
      { t: 'Biblioteca', d: 'el repositorio del club; cada programa se asigna a cualquier fecha y grupo, cuantas veces se quiera.' },
      { t: 'Programa de hoy', d: 'el coach abre la app y ve la rutina del día con un botón "Entrenar" por grupo.' },
      { t: 'Flyer imprimible', d: 'con la marca del club: timetable con horas reales por sección, listo para WhatsApp o PDF.' },
    ],
    beneficio:
      'El conocimiento deportivo deja de vivir en la cabeza de una persona. Las rutinas se estandarizan y el club proyecta profesionalismo.',
  },
  {
    id: 'm08',
    num: '08',
    parte: 'Entrenamientos',
    chip: 'Plan Club+',
    titulo: 'Modo en vivo — el cronómetro que dirige la práctica',
    kw: 'cronometro en vivo timer reloj sincronizado estaciones sonido alertas pausar saltar recorrido',
    dolor: 'El plan escrito se abandona a los 10 minutos: nadie lleva el tiempo y cada estación dura lo que se siente.',
    solucion: [
      { t: 'Cronómetro gigante', d: 'en pantalla (que no se apaga): sección actual, cuenta regresiva y avisos con sonido al faltar 10 segundos y al cambiar de sección.' },
      { t: 'Controles de cancha', d: 'pausar, saltar sección, extender +1 o +5 minutos, regresar.' },
      { t: 'Reloj sincronizado en tiempo real', d: 'entre coaches y grupos: toda la cancha cambia de estación al mismo tiempo.' },
      { t: 'Resumen del recorrido', d: 'al terminar: duración real vs. planeada, pausas, secciones saltadas y distribución del tiempo.' },
    ],
    beneficio: 'El tiempo en cancha se aprovecha al minuto — y queda evidencia de cómo se entrenó realmente.',
  },
  {
    id: 'm09',
    num: '09',
    parte: 'Competencia',
    chip: 'Admin · Head Coach',
    titulo: 'Torneos — la competencia bajo control',
    kw: 'torneos liga copa inscripciones convocatoria dorsal standings tabla posiciones estadisticas record',
    dolor:
      'Qué grupos están inscritos, quién está convocado, cómo vamos en la tabla — todo disperso entre mensajes y fotos de convocatorias.',
    solucion: [
      { t: 'Torneos', d: 'con fechas, sede, formato (liga, copa, invitacional, amistoso…) y estado. Vista "Míos" para el coach.' },
      { t: 'Inscripciones con un clic', d: 'con opción de precargar el roster con los jugadores activos del grupo.' },
      { t: 'Roster del torneo', d: 'convocatoria con dorsal y estado (convocado, lesionado, suspendido) y staff autorizado para dirigir.' },
      { t: 'Tabla de posiciones automática', d: 'con los marcadores capturados: JJ, JG, JE, JP, puntos a favor y en contra, diferencia y puntos de tabla.' },
      { t: 'Estadísticas', d: 'récord, % de victorias, puntos a favor y en contra, promedio por juego.' },
    ],
    beneficio: 'El club sabe en todo momento cómo va la competencia — y la información es de todo el staff.',
  },
  {
    id: 'm10',
    num: '10',
    parte: 'Competencia',
    chip: 'Todos los roles',
    titulo: 'Juegos — programar, jugar, registrar',
    kw: 'juegos partidos marcador rival fase jornada cancha campo empalme resultado victoria derrota',
    dolor: 'Los partidos se avisan por chat, se olvidan, se empalman, y el resultado queda en la memoria.',
    solucion: [
      { t: 'Programación completa', d: 'fecha, hora, rival, fase, jornada, cancha y campo — con detección de empalmes.' },
      { t: 'Rivales de catálogo', d: 'se registran una vez (logo, colores) y se reutilizan, sin duplicados.' },
      { t: 'Agenda de torneos', d: 'el rol completo en vista calendario, agenda o rol, filtrable por torneo o grupo.' },
      { t: 'Día del partido', d: 'asistencia de un clic y captura del marcador al final. La tabla se actualiza sola.' },
    ],
    beneficio: 'Cero partidos olvidados y un historial completo de resultados sin trabajo extra.',
  },
  {
    id: 'm11',
    num: '11',
    parte: 'Competencia',
    chip: 'Staff del grupo',
    titulo: 'Tarjetón — la inscripción de liga en minutos',
    kw: 'tarjeton cedula nomina credenciales liga inscripcion imprimir curp fotos firma delegado',
    dolor:
      'Cada liga exige su papelería: cédula, nómina con CURP y credenciales con foto. Armarla a mano toma una tarde y cualquier error regresa el trámite.',
    solucion: [
      { t: 'Hoja de nómina', d: 'con logos de liga y club: número, nombre, grado escolar, fecha de nacimiento y CURP.' },
      { t: 'Cédula de inscripción', d: 'con datos del equipo y líneas de firma.' },
      { t: 'Credenciales individuales', d: '(8 por hoja) con foto — incluyendo las del entrenador y asistente.' },
    ],
    beneficio: 'El trámite más tedioso de la temporada pasa de una tarde a un par de minutos.',
  },
  {
    id: 'm12',
    num: '12',
    parte: 'Cobranza',
    chip: 'Plan Club+',
    titulo: 'Planes de pago — define el cobro una vez',
    kw: 'plan de pago parcialidades mensualidades cargos entregables cuadrar total alcance aplicar recalcular colegiatura',
    dolor:
      'Calcular cuánto cuesta la temporada, en cuántos pagos y con qué fechas — jugador por jugador. Un error de suma y las cuentas no cuadran nunca más.',
    solucion: [
      { t: 'Asistente de 5 pasos', d: 'datos y alcance (todos, un grupo, una familia o un jugador) → conceptos → parcialidades → entregables → revisar y aplicar.' },
      { t: 'Cuadre obligatorio', d: 'las parcialidades deben sumar exacto el total; "Ajustar para cuadrar" mete la diferencia en el último pago.' },
      { t: 'Entregables', d: 'qué recibe el jugador (uniforme, credencial) y después de qué pago se libera.' },
      { t: 'Recálculo seguro', d: 'al editar: modo "solo pendientes" que no toca a quien ya pagó, con vista previa del impacto.' },
    ],
    beneficio:
      'El esquema de cobro se define una vez y el sistema genera los cargos de decenas de jugadores en segundos — cuadrados al centavo.',
  },
  {
    id: 'm13',
    num: '13',
    parte: 'Cobranza',
    chip: 'Plan Club+',
    titulo: 'Dashboard de pagos — la salud financiera',
    kw: 'dashboard cobranza vencido pendiente cobrado morosidad tesorero corte finanzas',
    dolor: '"¿Cuánto nos deben?" es la pregunta que el tesorero no puede responder sin una noche de Excel.',
    solucion: [
      { t: 'Por temporada', d: 'total por cobrar, cobrado, pendiente y vencido, con barra de avance de cobranza.' },
      { t: 'Tabla de morosidad', d: 'por jugador o por familia, con lo vencido en rojo.' },
      { t: 'Exportable', d: 'a PDF y Excel.' },
    ],
    beneficio: 'La mesa directiva tiene el corte en tiempo real, y la cobranza se enfoca en los vencidos.',
  },
  {
    id: 'm14',
    num: '14',
    parte: 'Cobranza',
    chip: 'Plan Club+',
    titulo: 'Registro de pagos — el libro de ingresos',
    kw: 'registrar pago efectivo transferencia tarjeta comprobante saldo a favor anular referencia libro ingresos',
    dolor:
      'Los pagos llegan por efectivo, transferencia y tarjeta, a distintas manos — y conciliar qué pago cubre qué mensualidad es un rompecabezas.',
    solucion: [
      { t: 'Registrar un pago', d: 'elegir jugador, marcar los cargos que cubre (el monto se suma solo) o registrarlo como pago a cuenta, con método, referencia y comprobante adjunto.' },
      { t: 'Saldo a favor automático', d: 'los sobrantes quedan disponibles y se aplican a los cargos más antiguos primero.' },
      { t: 'Esta lista es solo dinero que entró', d: 'cuando un saldo a favor se aplica a un cargo no aparece aquí (no entró dinero nuevo): esos movimientos se ven en el Estado de cuenta del jugador.' },
      { t: 'Anular exige motivo', d: 'y deja rastro: quién, cuándo y por qué.' },
    ],
    beneficio: 'Cada peso que entra queda documentado, aplicado al cargo correcto y auditable.',
  },
  {
    id: 'm15',
    num: '15',
    parte: 'Cobranza',
    chip: 'Plan Club+',
    titulo: 'Estado de cuenta y Cuentas (familias)',
    kw: 'estado de cuenta cuentas familias hermanos tutor saldo debe al corriente descuentos',
    dolor:
      'Las familias con 2 o 3 hijos son un enredo: cargos separados, descuentos de hermanos a mano, y el papá preguntando el total por WhatsApp.',
    solucion: [
      { t: 'Cuentas por familia', d: 'con un tutor responsable: cada cargo, su descuento, lo pagado, el saldo y el vencimiento — "Debe $X" o "Al corriente".' },
      { t: 'Entregables visibles', d: 'listo para recoger o cuánto falta para liberarlo.' },
      { t: 'Descuentos asignables', d: 'desde la misma vista.' },
    ],
    beneficio: 'Una sola vista responde la pregunta más frecuente del club — "¿cuánto debo?" — por familia completa.',
  },
  {
    id: 'm16',
    num: '16',
    parte: 'Cobranza',
    chip: 'Público · link + PIN',
    titulo: 'Portal para padres — transparencia sin cuentas',
    kw: 'portal padres papas link pin whatsapp compartir reportar pago comprobante spei sin cuenta publico',
    dolor:
      'Dar acceso a los papás significa crear usuarios y dar soporte. Sin acceso, el club vive contestando estados de cuenta por chat.',
    solucion: [
      { t: 'Un link + un PIN de 4 dígitos', d: 'por familia, compartido por WhatsApp con mensaje pre-armado. Sin instalar nada.' },
      { t: 'El papá ve', d: 'el saldo de la familia y de cada hijo, vencimientos, pagos aplicados, equipo prestado y entregables.' },
      { t: 'Reportar un pago', d: 'selecciona los cargos (incluso de varios hijos en una sola transferencia), sube el comprobante y lo envía a revisión.' },
      { t: 'Seguridad', d: 'bloqueo tras 5 intentos fallidos; el club regenera link o PIN cuando quiera.' },
    ],
    beneficio: 'Los papás se autoatienden y el club deja de ser call center. Cero "es que no sabía que debía".',
  },
  {
    id: 'm17',
    num: '17',
    parte: 'Cobranza',
    chip: 'Plan Club+',
    titulo: 'Solicitudes — conciliación con un clic',
    kw: 'solicitudes aprobar rechazar comprobante antivirus conciliar revision corregir reenviar',
    dolor:
      'El comprobante llega por WhatsApp, se pierde entre memes, y tres semanas después nadie sabe si ese SPEI ya se registró.',
    solucion: [
      { t: 'Bandeja de solicitudes', d: 'con contador visible en el menú y comprobante con escaneo antivirus automático.' },
      { t: 'Aprobar', d: 'el admin ajusta cuánto se aplica a cada cargo; el sobrante va a saldo a favor. El pago real se crea solo.' },
      { t: 'Rechazar con motivo', d: 'visible para el papá, que puede corregir y reenviar con los datos precargados.' },
    ],
    beneficio: 'Circuito cerrado: el papá reporta, el club valida, el estado de cuenta se actualiza — todos ven lo mismo.',
  },
  {
    id: 'm18',
    num: '18',
    parte: 'Cobranza',
    chip: 'Plan Club+',
    titulo: 'Conceptos y Promociones',
    kw: 'conceptos promociones descuentos becas cortesias hermanos escalonado inscripcion mensualidad catalogo precios',
    dolor: 'Precios y descuentos como acuerdos verbales que cada quien recuerda distinto.',
    solucion: [
      { t: 'Conceptos', d: 'el catálogo de "lo que cuesta" (inscripción, mensualidad, uniforme, evento) con montos sugeridos. Un concepto en uso no puede borrarse.' },
      { t: 'Promociones con reglas', d: 'becas, cortesías y descuento por hermanos escalonado (2º hijo X%, 3º hijo Y%), por alcance y por plan o concepto.' },
      { t: 'Recálculo con vista previa', d: 'al editar o desactivar — sin tocar lo ya pagado.' },
    ],
    beneficio: 'Los precios del club son política escrita, consistente y auditable.',
  },
  {
    id: 'm19',
    num: '19',
    parte: 'Uniformes e inventario',
    chip: 'Plan Pro',
    titulo: 'Uniformes — de la talla al reparto',
    kw: 'uniformes prendas tallas pedidos reparto proveedor extras jersey playera pagado cobro caja medir temporada',
    dolor:
      '¿Qué talla es cada niño? ¿Qué le pedimos al proveedor? ¿Quién ya pagó? ¿A quién ya se le entregó? Todo en una libreta que se contradice a sí misma.',
    solucion: [
      { t: 'Prendas y "De la temporada"', d: 'el catálogo por deporte con tallas y precio, y aparte qué se manda a hacer ESTE ciclo. Su concepto de cobro se genera solo — precio y cargo nunca se desalinean.' },
      { t: 'Tallas', d: 'por prenda (eliges jersey y pasas la lista) o por jugador (un renglón por niño con todas sus prendas, para el día que mides al equipo). Sin talla no se puede pedir nada.' },
      { t: 'Pedidos', d: 'se arma con lo que ya tiene talla y se le pone fecha de pago. Cada pieza toma esa fecha: si ya tenía cobro se le fija, y si no, se le genera — y el papá lo ve en su estado de cuenta. Al marcarlo listo se congela el número y el apodo que van bordados.' },
      { t: 'Reparto', d: 'cuando llega la caja. Se filtra por pedido —una caja es un pedido— y dice cuánto llegó y cuánto queda. Si el pago no está cubierto avisa antes de entregar: la decisión sigue siendo del club.' },
      { t: 'Extras', d: 'lo que se vende aparte del plan (un segundo jersey, una playera de porra) genera su propio cargo al asignarlo y sigue el mismo camino.' },
    ],
    beneficio: 'Qué talla, qué se pidió, quién pagó y si ya se entregó es un dato, no una discusión. Y cuando el uniforme va dentro del plan, la app dice "Sin cobro propio" en vez de acusar de no haber pagado a quien está al corriente.',
  },
  {
    id: 'm20',
    num: '20',
    parte: 'Uniformes e inventario',
    chip: 'Plan Pro',
    titulo: 'Inventario — el equipo del club, ubicado y contado',
    kw: 'inventario articulos prestamos devoluciones conteos existencias balones conos cascos equipo reporte kardex',
    dolor:
      'Conos, balones y cascos se compran cada año… y desaparecen cada año. Nadie sabe cuántos hay ni quién se llevó qué.',
    solucion: [
      { t: 'Catálogo de artículos', d: 'con categoría, deporte, ubicación y existencias en vivo: total, prestados, disponibles.' },
      { t: 'Préstamos y asignaciones', d: 'a jugadores, staff o externos, con devolución registrada y aviso de sobre-préstamo.' },
      { t: 'Equipo por jugador', d: 'la lista para exigir devoluciones a fin de temporada (visible en el portal del padre).' },
      { t: 'Conteos físicos', d: 'lo contado vs. lo esperado, con ajustes aplicados al cerrar y evidencia de solo lectura.' },
      { t: 'Reporte de movimientos', d: 'por temporada: inicial, agregados, perdidos, desechados, ajustes y final.' },
    ],
    beneficio: 'El patrimonio del club deja de evaporarse. Cada casco tiene historia.',
  },
  {
    id: 'm21',
    num: '21',
    parte: 'Administración',
    chip: 'Admin',
    titulo: 'Jugadores — el padrón único',
    kw: 'jugadores padron curp csv importar excel documentos fotos tutor emergencia ficha alta baja perfil enlace compartir filtros volver pestanas',
    dolor:
      'Los datos viven en tres Excel distintos, con duplicados, sin CURP, sin foto y sin los datos del tutor cuando hay una emergencia.',
    solucion: [
      { t: 'Ficha completa', d: 'datos personales, foto, tutor, responsable de pago, contacto de emergencia y documentos configurables.' },
      { t: 'CURP validada en serio', d: '(formato, dígito verificador, coherencia con nacimiento y sexo) — obligatoria para activar.' },
      { t: 'Importación por CSV', d: 'con plantilla, vista previa que clasifica filas (nuevos / duplicados / con error) y reporte final.' },
      { t: 'Ficha con su propia dirección', d: 'cada jugador tiene su pantalla y su enlace: lo puedes copiar, mandar por WhatsApp o guardar en favoritos, y el botón "atrás" del navegador funciona como esperas.' },
      { t: 'Cuatro pestañas en la ficha', d: 'Información, Grupos, Uniformes y Documentos — todo lo del jugador sin salir de ahí.' },
      { t: 'Volver no te tira los filtros', d: 'si llegaste buscando "los de 2015 sin CURP", al salir de la ficha la lista sigue como la dejaste. Solo se pierde si abriste la ficha desde un enlace pegado, que es lo correcto.' },
      { t: 'Protección de menores', d: 'minimización de datos — el contacto es siempre el tutor.' },
    ],
    beneficio: 'Un solo padrón confiable que alimenta asistencia, cobros, torneos y tarjetón — sin recapturar jamás.',
  },
  {
    id: 'm22',
    num: '22',
    parte: 'Administración',
    chip: 'Admin · Portal público',
    titulo: 'Consentimientos — cumplimiento sin fricción',
    kw: 'consentimientos lfpdppp privacidad firma whatsapp tutor menores uso de imagen aviso activar legal',
    dolor:
      'La ley (LFPDPPP) exige consentimiento del tutor para tratar datos de menores — y los clubes lo resuelven con hojas firmadas que se pierden, o no lo resuelven.',
    solucion: [
      { t: 'Semáforo', d: 'firmados, pendientes, sin solicitar.' },
      { t: 'Solicitud por WhatsApp', d: 'con un clic: un enlace único por familia (cubre a los hermanos).' },
      { t: 'Página de firma', d: 'sin cuenta ni descarga: acepta el tratamiento y decide por separado el uso de imagen. Queda fecha y versión como evidencia.' },
      { t: 'Puerta de activación', d: '(opcional): sin firma + CURP, el jugador no pasa a Activo.' },
    ],
    beneficio: 'El club queda protegido legalmente con evidencia ordenada — y al papá le toma un minuto desde su celular.',
  },
  {
    id: 'm23',
    num: '23',
    parte: 'Administración',
    chip: 'Admin',
    titulo: 'Staff — acceso a la medida de cada quien',
    kw: 'staff coaches invitar acceso roles contrasena correo baja fundador permisos equipo de trabajo',
    dolor: 'Todos comparten una contraseña — o peor: el coach que se fue sigue teniendo acceso a todo.',
    solucion: [
      { t: 'Cuenta propia por invitación', d: 'de correo; el rol define lo que ve.' },
      { t: 'Coaches asignados a sus grupos', d: '— solo ven esos.' },
      { t: 'Baja inmediata', d: 'dar de baja corta el acceso al instante.' },
      { t: 'Admin fundador protegido', d: 'nadie puede degradarlo ni eliminarlo.' },
    ],
    beneficio: 'Seguridad real sin fricción: cada quien entra con lo suyo y las salidas no dejan puertas abiertas.',
  },
  {
    id: 'm24',
    num: '24',
    parte: 'Administración',
    chip: 'Admin',
    titulo: 'Grupos, Categorías y Temporadas',
    kw: 'grupos categorias temporadas inscripciones inscribir estructura rama tackle peso edad nacimiento no hay jugadores para este plan',
    dolor: 'Sin una estructura clara, cada cobro, lista y reporte se arma a mano y de memoria.',
    solucion: [
      { t: 'Grupos', d: 'deporte, rama, categorías permitidas, staff y roster. Registrar un jugador no lo mete a un grupo — asignarlo es un paso aparte.' },
      { t: 'Categorías', d: 'rangos por edad o año de nacimiento — y para tackle, límites de peso. Siempre en lenguaje claro: "Nacidos 2015-2016 · 10-11 años".' },
      { t: 'Temporadas', d: 'un deporte, un periodo. Quién participa en ella se decide en Administración → Inscripciones, jugador por jugador o en lote: nada se inscribe solo. Solo los inscritos pueden entrar a un grupo y solo ellos reciben cargos — si un plan dice "No hay jugadores", casi siempre falta inscribirlos.' },
    ],
    beneficio: 'La estructura se modela una vez y todo lo demás se cuelga de ella sin ambigüedad.',
  },
  {
    id: 'm25',
    num: '25',
    parte: 'Administración',
    chip: 'Admin',
    titulo: 'Organización — identidad y reglas del club',
    kw: 'organizacion configuracion logo colores marca branding aviso privacidad arco documentos compartir plan uso',
    dolor: 'El sistema genérico que no se siente propio, y los datos legales del club regados por ahí.',
    solucion: [
      { t: 'Marca propia', d: 'nombre, logo y colores — la app entera (y el portal de los papás) toma la identidad del club.' },
      { t: 'Datos legales', d: 'razón social, domicilio y correo ARCO, que alimentan el Aviso de Privacidad generado automáticamente.' },
      { t: 'Reglas explícitas', d: 'puerta de consentimiento y tipos de documento requeridos. Lo que se comparte con la organizadora de un torneo es fijo (nombre, número, categoría, fecha de nacimiento, CURP y foto de cada jugador, y nombre y foto del cuerpo técnico) y está a la vista; contactos y pagos, nunca.' },
      { t: 'Plan y uso', d: 'consumo actual contra los límites del plan.' },
    ],
    beneficio: 'La app se ve del club, y las decisiones de privacidad son configuración explícita, no accidentes.',
  },
  {
    id: 'm26',
    num: '26',
    parte: 'Administración',
    chip: 'Admin',
    titulo: 'Herramientas de mantenimiento',
    kw: 'herramientas terminar sesiones recalcular retencion purga documentos mantenimiento',
    solucion: [
      { t: 'Terminar sesiones', d: 'cierra en bloque entrenamientos y juegos de días pasados que quedaron abiertos, con resumen previo.' },
      { t: 'Recalcular jugadores', d: 're-deriva deportes y categorías a partir de los grupos actuales.' },
      { t: 'Aplicar retención', d: 'purga (con vista previa y confirmación) documentos de jugadores dados de baja hace más de 12 meses, conservando la evidencia de consentimiento.' },
    ],
    beneficio: 'Calendario, padrón y privacidad consistentes sin trabajo manual sesión por sesión.',
  },
  {
    id: 'm27',
    num: '27',
    parte: 'Tu cuenta y tu plan',
    chip: 'Starter · Club · Pro',
    titulo: 'Planes MYKLUBB — crece con tu club',
    kw: 'planes precios starter club pro limites modulos candado suscripcion perfil contrasena upgrade',
    intro:
      'Cada usuario gestiona su perfil (foto, teléfono, contraseña). Los módulos no incluidos en tu plan aparecen con un candado en el menú — ves lo que existe y decides cuándo crecer. La solicitud de cambio de plan se hace desde "Planes y precios" (mensual o anual, MXN o USD).',
    planes: [
      { f: 'Núcleo: grupos, jugadores, asistencia, torneos', starter: '✓', club: '✓', pro: '✓' },
      { f: 'Límites (jugadores / grupos / staff)', starter: '30 / 2 / 3', club: 'Ampliados', pro: 'Ampliados' },
      { f: 'Programas de entrenamiento', starter: '—', club: '✓', pro: '✓' },
      { f: 'Cobranza y portal de padres', starter: '—', club: '✓', pro: '✓' },
      { f: 'Branding personalizado', starter: '—', club: '✓', pro: '✓' },
      { f: 'Uniformes', starter: '—', club: '—', pro: '✓' },
      { f: 'Inventario', starter: '—', club: '—', pro: '✓' },
      { f: 'Exportación a PDF', starter: '—', club: '—', pro: '✓' },
    ],
    beneficio: 'Empiezas gratis y el sistema crece contigo, sin migrar de plataforma.',
  },
  {
    id: 'g-dia',
    num: '★',
    parte: 'Guías',
    chip: 'Resumen',
    titulo: 'El día de un club con MYKLUBB',
    kw: 'dia resumen ejemplo flujo jornada tipico como se ve',
    dia: [
      { hora: '7:00', texto: 'El coach abre la app: pantalla Hoy, un clic y está pasando lista.' },
      { hora: '7:05', texto: 'Arranca el programa en vivo: el cronómetro dirige la práctica, sincronizado entre los tres grupos de la cancha.' },
      { hora: '10:00', texto: 'Un papá abre su portal, ve que debe la mensualidad, transfiere y sube su comprobante.' },
      { hora: '10:30', texto: 'La administradora aprueba la solicitud en dos clics; el estado de cuenta se actualiza solo.' },
      { hora: '12:00', texto: 'Llegan los uniformes: la estación de entrega captura tallas y marca entregas, avisando quién aún no cubre su pago.' },
      { hora: 'Sábado', texto: 'Juego de liga: asistencia del partido, marcador al final, y la tabla del torneo se recalcula sola.' },
      { hora: 'Fin de mes', texto: 'El reporte de asistencia mensual y el corte de cobranza salen en dos clics.' },
    ],
    beneficio: 'Un solo sistema. Un solo padrón. Cero recaptura.',
  },
];

export const TIPS = [
  {
    tema: 'Para arrancar',
    items: [
      { q: 'Configurar el club paso a paso (guía de inicio)', id: 'g-arranque' },
      { q: 'Invitar a mis coaches y darles acceso', id: 'm23' },
      { q: 'Importar mis jugadores desde Excel (CSV)', id: 'm21' },
      { q: '"No hay jugadores para este plan": qué me faltó', id: 'm24' },
    ],
  },
  {
    tema: 'El día a día',
    items: [
      { q: 'Pasar lista desde el celular', id: 'm03' },
      { q: 'Ver qué grupos no han tomado asistencia', id: 'm04' },
      { q: 'Programar los entrenamientos de toda la temporada', id: 'm05' },
      { q: 'Sacar el reporte mensual de asistencia', id: 'm06' },
    ],
  },
  {
    tema: 'Cobranza',
    items: [
      { q: 'Crear mi plan de pago con parcialidades', id: 'm12' },
      { q: 'Compartir el estado de cuenta a un papá (link + PIN)', id: 'm16' },
      { q: 'Aprobar los pagos que reportan las familias', id: 'm17' },
      { q: 'Aplicar descuento por hermanos o becas', id: 'm18' },
    ],
  },
  {
    tema: 'Competencia',
    items: [
      { q: 'Inscribir a mi grupo a un torneo', id: 'm09' },
      { q: 'Programar juegos y capturar marcadores', id: 'm10' },
      { q: 'Generar el tarjetón para la liga', id: 'm11' },
    ],
  },
  {
    tema: 'Entrenamiento pro',
    items: [
      { q: 'Armar una rutina con secciones cronometradas', id: 'm07' },
      { q: 'Usar el cronómetro en vivo en la cancha', id: 'm08' },
    ],
  },
  {
    tema: 'Uniformes, inventario y legal',
    items: [
      { q: 'Capturar tallas, pedir uniformes y repartirlos', id: 'm19' },
      { q: 'Controlar préstamos de equipo del club', id: 'm20' },
      { q: 'Pedir el consentimiento del tutor por WhatsApp', id: 'm22' },
    ],
  },
];

// Rango de diacríticos combinantes (U+0300–U+036F) construido en ASCII puro
// para que ninguna herramienta corrompa el archivo.
const DIACRITICOS = new RegExp('[' + String.fromCharCode(768) + '-' + String.fromCharCode(879) + ']', 'g');
// Procedimientos paso a paso por tema (rutas reales de menú y botones).
const COMO = {
  m01: [
    'Entra a la app: "Hoy" es la pantalla de inicio (también está en el menú).',
    'En "Entrenamientos de hoy", toca "Tomar asistencia" en la tarjeta de tu grupo.',
    'Para un partido, usa la tarjeta en "Juegos de hoy" → "Asistencia".',
    '¿Práctica no programada? Abajo, en "Tomar asistencia de otro grupo", elige el grupo y toca "Ir".',
  ],
  m02: [
    'Menú → "Mis grupos" (o "Ver todos los grupos").',
    'Toca "Ver" en el grupo para abrir su panel.',
    'Recorre las secciones: Entrenamientos, Torneos y Jugadores.',
    'Toca "Entrenar" para la asistencia de hoy, o "Editar" para los datos del grupo.',
    'En Jugadores → "Asignar jugadores" agregas o quitas del roster.',
  ],
  m03: [
    'Desde "Hoy" toca "Tomar asistencia" (o Mis grupos → "Entrenar").',
    'Toca la tarjeta de cada jugador: cicla Presente → Retardo → Ausente → Exento y se guarda solo.',
    'Usa "Todos presentes" o "Todos ausentes" para resolver los pendientes.',
    'Al acabar toca "Terminar sesión": los sin marcar quedan como ausentes (te lo confirma antes).',
    '¿Te equivocaste? "Reactivar sesión" y corrige. En juegos, al terminar captura el marcador con "Editar marcador".',
  ],
  m04: [
    'Menú → Agendas → "Agenda de entrenamientos".',
    'Abre "Filtros" para elegir rango de fechas, grupos o series.',
    'Toca una celda con punto para ver presentes, retardos y ausentes de esa sesión.',
    'Desde el panel: "Entrenar" abre esa asistencia; "Terminar entrenamiento" la cierra.',
  ],
  m05: [
    'Menú → Entrenamientos → "Series" (solo admin).',
    'Toca "Nueva Serie": nombre, grupo(s), días de la semana, horario y fechas.',
    'Guarda y usa "Generar eventos": elige el rango (hasta 6 meses) y se crean las sesiones.',
    'Cuando quieras extender el calendario, corre el generador otra vez — no duplica.',
  ],
  m06: [
    'Menú → Entrenamientos → "Asistencia mensual".',
    'Elige Grupo, Mes y Año (y una Serie, si quieres acotar).',
    'Lee la matriz: P asistió, R retardo, F faltó, J justificado, E exento, y el % por jugador.',
    'Toca "Exportar a Excel" o "Imprimir" para entregarlo.',
  ],
  m07: [
    'Menú → Entrenamientos → "Programas" (la Biblioteca es para admin/head coach).',
    '"Nuevo programa": llena Información (deportes, habilidades), Secciones (importa plantillas y define minutos) y Material (PDF o fotos).',
    'Guarda y toca "Asignar a otro día": elige fechas y grupos.',
    'El coach lo verá en "Programa de hoy" la fecha asignada.',
    'Con "Compartir / Imprimir" generas el flyer con horarios para WhatsApp o PDF.',
  ],
  m08: [
    'Abre la asistencia del grupo (Hoy → "Tomar asistencia").',
    'En la tarjeta del programa asignado toca "Iniciar Modo entrenamiento".',
    'Controla desde la cancha: Pausar, Saltar, +1 min, +5 min, Anterior.',
    'Los demás coaches tocan "Unirse al entrenamiento en vivo" — el reloj se sincroniza solo.',
    'Al final toca "Terminar": se genera el resumen del recorrido.',
  ],
  m09: [
    'Menú → Torneos → "Torneos" y toca "Nuevo torneo" (nombre, liga, tipo, fechas).',
    'Abre el torneo y toca "Inscribir grupo" — deja marcado precargar el roster.',
    'En la inscripción ajusta el Roster (dorsal, convocado/lesionado/suspendido) y el Staff autorizado.',
    'Captura los marcadores de los juegos: Posiciones y Estadísticas se llenan solos.',
  ],
  m10: [
    'Menú → Torneos → "Juegos" y toca "Crear juego".',
    'Elige torneo → grupo → rival (puedes crear el rival ahí mismo), fecha, hora, fase y cancha.',
    'El día del partido, toca "Asistencia" en la tarjeta del juego.',
    'Al acabar: "Terminar juego" y luego "Editar marcador" para capturar el resultado.',
  ],
  m11: [
    'Ve a Mis grupos y abre el grupo.',
    'En la sección Torneos, toca "Tarjetón" junto al torneo.',
    'Revisa nómina, cédula y credenciales — fotos y CURP salen del padrón.',
    'Toca "Imprimir". Si falta un dato, corrígelo en Administración → Jugadores y regresa.',
  ],
  m12: [
    'Menú → Pagos → "Planes" y toca "Nuevo plan".',
    'Sigue el asistente: Datos y alcance → Conceptos → Parcialidades (usa "Generar pagos" y "Ajustar para cuadrar") → Entregables → Revisar.',
    'El alcance define CÓMO se asigna el plan (libre, por grupo, por familia o individual), no a quién: eso se elige después.',
    'Toca "Guardar y asignar": te lleva a Pagos → "Asignaciones" con el plan ya elegido.',
    'Ahí marca a quién: cambia entre Jugadores, Familias o Grupos, filtra (por ejemplo "sin plan") y usa "Seleccionar todos" si van muchos. Antes de confirmar verás a cuántos se les generará el cargo y por cuánto.',
    'Si no aparece nadie, casi siempre falta inscribirlos: Administración → Inscripciones.',
    'Para editar un plan ya asignado, usa "Recalcular cargos" — la vista previa te muestra el impacto antes.',
  ],
  m13: [
    'Menú → Pagos → "Resumen".',
    'Elige la temporada arriba.',
    'Revisa las tarjetas (por cobrar, cobrado, pendiente, vencido) y la tabla "Cobranza Pendiente" por jugador o familia.',
    'Exporta con "Descargar PDF" o "Exportar Excel".',
  ],
  m14: [
    'Menú → Pagos → "Pagos" y toca "Registrar pago".',
    'Busca al jugador y marca los cargos que cubre (o elige "Pago a cuenta" para saldo a favor).',
    'Captura método, referencia y adjunta el comprobante. Guarda.',
    'Para anular un pago usa su acción de anular — te pedirá el motivo.',
  ],
  m15: [
    'Menú → Pagos → "Estado de cuenta".',
    'Busca la familia o jugador y expande su fila.',
    'Revisa cargos, descuentos, pagos y entregables por hijo.',
    '"Asignar descuento" aplica una promoción a un jugador puntual.',
    'Las cuentas (familias, tutor y PIN) se administran en Administración → "Cuentas".',
  ],
  m16: [
    'Menú → Pagos → "Estado de cuenta" y toca "Compartir" en la familia (a un jugador sin cuenta se le crea una automáticamente).',
    'Copia el link o toca "Enviar por WhatsApp" — el mensaje va pre-armado.',
    'Entrega también el PIN de 4 dígitos: se muestra una sola vez (puedes generar uno nuevo ahí mismo).',
    'El papá abre el link, teclea su PIN y ve saldos, cargos y entregables.',
    'Si se bloqueó por intentos fallidos, en el mismo diálogo toca "Desbloquear ahora".',
  ],
  m17: [
    'Menú → Pagos → "Solicitudes" (el número ámbar en el menú son las pendientes).',
    'Abre la solicitud y toca "Ver comprobante" (espera el escaneo antivirus).',
    'Toca "Aprobar" y ajusta cuánto se aplica a cada cargo — el sobrante va a saldo a favor.',
    'O "Rechazar" con un motivo claro: el papá lo ve y puede corregir y reenviar.',
  ],
  m18: [
    'Menú → Pagos → "Conceptos": crea cada concepto con tipo y monto sugerido (los de uniforme se administran en Uniformes).',
    'Menú → Pagos → "Promociones": "Nueva promoción" con tipo (hermano, beca, cortesía), alcance y descuento.',
    'Al editar una promo, elige si recalcula solo cargos pendientes o todos.',
    'Para un caso puntual, asigna el descuento desde Estado de cuenta.',
  ],
  m19: [
    'Menú → Uniformes → "Prendas": "Nueva Prenda" (su concepto de cobro se crea solo).',
    'En "De la temporada" marca qué prendas se mandan a hacer este ciclo.',
    'Para que una prenda vaya dentro de un plan de pago, agrégala desde Pagos → Planes, paso "Conceptos".',
    'Para prendas fuera del plan usa "Extras": genera su propio cargo.',
    'Captura las tallas en "Tallas" (por prenda, o por jugador el día que mides al equipo). Sin talla no se puede pedir.',
    'Arma el pedido en "Pedidos" y márcalo listo cuando esté completo.',
    'Cuando llegue la caja, reparte en "Reparto": la vista "Avance" te dice cuánto llevas.',
  ],
  m20: [
    'Menú → Inventario → "Artículos": registra artículos y sus entradas con "Registrar movimiento".',
    '"Préstamos" → "Nuevo préstamo": elige artículo y a quién (jugador, staff o externo). Al regresar, "Devolver".',
    '"Por jugador" muestra qué tiene cada quien — útil a fin de temporada.',
    '"Conteos" → "Iniciar conteo": captura lo contado y "Cerrar conteo" aplica los ajustes.',
    '"Reporte" resume movimientos por temporada o rango.',
  ],
  m21: [
    'Menú → Administración → "Jugadores" → "Nuevo jugador" (la CURP es obligatoria para ponerlo Activo).',
    'Para migrar tu Excel: "Importar" → descarga la plantilla → sube el CSV → revisa la vista previa → importa.',
    'Toca un jugador de la lista para abrir su ficha: Información, Grupos, Uniformes y Documentos. Fotos y documentos se suben ahí.',
    'La ficha tiene su propia dirección: copia la del navegador para compartirla o guardarla.',
    'No olvides el paso 2: asignarlo a un grupo en Administración → Grupos → "Ver" → agregar al roster.',
  ],
  m22: [
    'Menú → Administración → "Consentimientos".',
    'Selecciona a los jugadores "Sin solicitar" y toca "Solicitar" — se genera un enlace por familia.',
    'Toca "Compartir por WhatsApp": el mensaje va pre-armado con el nombre del club y del jugador.',
    'El tutor firma en la página del enlace; con la puerta activada, el jugador pasa a Activo.',
    'Para insistir sin duplicar, usa "Recordar" (reutiliza el mismo enlace).',
  ],
  m23: [
    'Menú → Administración → "Staff" → "Nuevo Staff": nombre, email y rol; deja marcada "Crear cuenta de acceso".',
    'La persona recibe un correo para crear su contraseña.',
    'Asigna sus grupos en Administración → Grupos (editar grupo → staff).',
    '¿No le llegó el correo? Toca "Reenviar invitación".',
    'Para dar de baja: "Desactivar" — el acceso se corta al instante.',
  ],
  m24: [
    'Administración → "Categorías": ajusta las que vienen sembradas a tu club.',
    'Administración → "Temporadas": crea la temporada (un deporte, un periodo) y ábrela.',
    'Administración → "Inscripciones": elige la temporada y marca quién participa este ciclo. Puedes inscribir en lote (filtra, selecciona todos, "Inscribir seleccionados").',
    'Administración → "Grupos": crea los grupos y arma el roster. Para entrar a un grupo hay que estar inscrito en la temporada de ese deporte; si falta alguien, la pantalla te ofrece inscribirlo ahí mismo.',
    'Regla de oro: registrar ≠ inscribir ≠ agrupar — son tres pasos distintos, y van en ese orden.',
  ],
  m25: [
    'Toca tu avatar (abajo del menú) → "Organización".',
    'Configura identidad, logo y colores del club.',
    'Llena los datos legales y el correo ARCO — alimentan tu Aviso de Privacidad.',
    'Activa la puerta de consentimiento y marca los documentos requeridos.',
    'Toca "Guardar cambios".',
  ],
  m26: [
    'Menú → "Herramientas" (solo admin).',
    '"Terminar sesiones": revisa el resumen (entrenamientos/juegos) y confirma.',
    '"Recalcular jugadores": úsalo tras reacomodos de grupos.',
    '"Aplicar retención": revisa la vista previa antes de confirmar — la purga es irreversible.',
  ],
  m27: [
    'Toca tu avatar (abajo del menú) → "Planes y precios".',
    'Compara Starter, Club y Pro (mensual o anual, MXN o USD).',
    'El admin fundador puede tocar "Solicitar cambio de plan" y agregar una nota.',
    'MYKLUBB revisa y aprueba la solicitud — te avisamos en la misma pantalla.',
  ],
};

TEMAS.forEach((t) => {
  if (COMO[t.id]) t.como = COMO[t.id];
});

const stripAccents = (s) => (s || '').normalize('NFD').replace(DIACRITICOS, '').toLowerCase();

const temaTextoPlano = (t) => {
  const partes = [
    t.titulo,
    t.kw,
    t.chip,
    t.parte,
    t.intro,
    t.dolor,
    t.beneficio,
    ...(t.solucion || []).map((s) => `${s.t} ${s.d}`),
    ...(t.como || []),
    ...(t.pasos || []).map((p) => p.label || p),
    ...(t.dia || []).map((d) => `${d.hora} ${d.texto}`),
    ...(t.planes || []).map((p) => p.f),
  ];
  return partes.filter(Boolean).join(' ');
};

const INDICE = TEMAS.map((t) => ({ tema: t, hay: stripAccents(temaTextoPlano(t)) }));

export function buscarTemas(query) {
  const q = (query || '').trim();
  if (q.length < 2) return [];
  const terms = stripAccents(q).split(/\s+/).filter(Boolean);
  const hits = INDICE.filter((e) => terms.every((t) => e.hay.includes(t))).map((e) => e.tema);
  return hits.sort((a, b) => {
    const at = terms.some((t) => stripAccents(a.titulo).includes(t)) ? 0 : 1;
    const bt = terms.some((t) => stripAccents(b.titulo).includes(t)) ? 0 : 1;
    return at - bt;
  });
}
